import rmskincareAPI from '../utils/rmskincareAPI';

const categoryApi = {

    /* Category */
    getAllCategoryList: async(groupId) => {
        const result = await rmskincareAPI.get(`/management/category/${groupId}`);
        return result.data.data;
    },
    getOneCategoryAllProductList: async(categoryId) => {
        const result = await rmskincareAPI.get(`/management/category/product/${categoryId}`);
    },

    addCategory: async (requestBody) => {
        const result = await rmskincareAPI.post(`/management/category/save`, requestBody);
        return result.data.data;
    },
    deleteCategory: async (categoryId) => {
        const result = await rmskincareAPI.delete(`/management/category/del?id=${categoryId}`);
        return result.data.data;
    },
    editCategory: async (requestBody, categoryId) => {
        requestBody['id'] = categoryId;
        const result = await rmskincareAPI.post(`/management/category/save`, requestBody);
    }
}

export default categoryApi;